(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["see-it-in-action"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var carousel = root.querySelector('[data-siia-carousel]');
    var modal = document.querySelector('[data-siia-modal]');
    if (!carousel) return;

    // --- Center only while the row fits; left-align once it overflows --
    function updateCarouselAlignment() {
      var isOverflowing = carousel.scrollWidth > carousel.clientWidth + 1; // +1 guards against sub-pixel rounding
      carousel.classList.toggle('siia-carousel--scrollable', isOverflowing);
    }

    updateCarouselAlignment();

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateCarouselAlignment).observe(carousel);
    } else {
      window.addEventListener('resize', updateCarouselAlignment);
    }

    // --- Random one-at-a-time muted preview rotation --------------------
    // Only one clip plays (muted) at any moment, for ROTATION_MS, then
    // pauses and a different random clip takes over. The cycle only runs
    // while the section is actually on-screen, and respects a user's
    // reduced-motion preference by leaving everything on its poster frame.
    var videos = Array.prototype.slice.call(root.querySelectorAll('[data-siia-video]'));
    var ROTATION_MS = 5000;
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (videos.length && !prefersReducedMotion) {
      var currentIndex = -1;
      var rotationTimeoutId = null;
      var isRotating = false;

      function pickNextIndex() {
        if (videos.length === 1) return 0;
        var next;
        do {
          next = Math.floor(Math.random() * videos.length);
        } while (next === currentIndex);
        return next;
      }

      function playNext() {
        if (currentIndex !== -1) {
          videos[currentIndex].pause();
          videos[currentIndex].currentTime = 0;
        }

        currentIndex = pickNextIndex();
        var video = videos[currentIndex];
        var playPromise = video.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(function () {
            /* Autoplay can be blocked by the browser; poster image remains visible. */
          });
        }

        rotationTimeoutId = window.setTimeout(playNext, ROTATION_MS);
      }

      function startRotation() {
        if (isRotating) return;
        isRotating = true;
        playNext();
      }

      function stopRotation() {
        isRotating = false;
        if (rotationTimeoutId) {
          window.clearTimeout(rotationTimeoutId);
          rotationTimeoutId = null;
        }
        if (currentIndex !== -1) {
          videos[currentIndex].pause();
        }
      }

      if ('IntersectionObserver' in window) {
        var sectionObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                startRotation();
              } else {
                stopRotation();
              }
            });
          },
          { threshold: 0.25 }
        );
        sectionObserver.observe(carousel);
      } else {
        // No IntersectionObserver support: just run the rotation regardless.
        startRotation();
      }
    }

    // --- Click-to-expand modal with sound -----------------------------
    if (modal) {
      var modalVideo = modal.querySelector('[data-siia-modal-video]');
      var modalContent = modal.querySelector('.siia-modal-content');

      // Freezes scrolling via overflow:hidden on body only (not
      // documentElement/<html> -- touching <html>'s overflow can clip
      // any position:fixed element elsewhere on the page whose
      // containing block ends up affected by it, which is almost
      // certainly what made the site header disappear). Body-only
      // overflow:hidden is the standard, low-risk version of this
      // technique and is what's used here.
      //
      // This also avoids touching window.scrollY (unlike a
      // position:fixed-on-body approach), so scroll-aware scripts
      // elsewhere on the page -- e.g. a header that reveals itself near
      // scrollY 0 -- don't see a false "scrolled to top" signal either.
      function lockPageScroll() {
        var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = 'hidden';
        if (scrollbarWidth > 0) {
          document.body.style.paddingRight = scrollbarWidth + 'px';
        }
      }

      function unlockPageScroll() {
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      }

      var modalCloseBtn = modal.querySelector('.siia-modal-close');

      root.querySelectorAll('[data-siia-trigger]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var previewVideo = btn.querySelector('[data-siia-video]');
          var sources = previewVideo ? previewVideo.querySelectorAll('source') : [];

          modalVideo.innerHTML = '';
          sources.forEach(function (src) {
            var clone = document.createElement('source');
            clone.src = src.src;
            clone.type = src.type;
            modalVideo.appendChild(clone);
          });
          modalVideo.load();
          modalVideo.muted = false;

          modal.hidden = false;
          lockPageScroll();
          modalVideo.play().catch(function () {});
        });
      });

      function closeModal() {
        modal.hidden = true;
        modalVideo.pause();
        modalVideo.removeAttribute('src');
        modalVideo.innerHTML = '';
        unlockPageScroll();
      }

      if (modalCloseBtn) {
        modalCloseBtn.addEventListener('click', closeModal);
      }

      // Close on any click that isn't inside the video/button wrapper --
      // attached to the whole overlay (not just the backdrop div), so it
      // doesn't depend on the backdrop's box exactly matching whatever
      // area looks "outside" the video (e.g. if the video's rendered box
      // doesn't fill its wrapper exactly). This is the single source of
      // truth for "clicked outside" rather than relying on a specific
      // element being hit.
      modal.addEventListener('click', function (e) {
        if (modalContent && !modalContent.contains(e.target)) {
          closeModal();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      });
    }

    // --- Mouse-drag scrolling on desktop -------------------------------
    var isDown = false;
    var startX, scrollLeft;

    carousel.addEventListener('mousedown', function (e) {
      isDown = true;
      startX = e.pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
    });
    ['mouseleave', 'mouseup'].forEach(function (evt) {
      carousel.addEventListener(evt, function () {
        isDown = false;
      });
    });
    carousel.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - carousel.offsetLeft;
      var walk = (x - startX) * 1.2;
      carousel.scrollLeft = scrollLeft - walk;
    });
  }

  document.querySelectorAll('[data-siia-section]').forEach(function (el) {
    init(el.closest('.shopify-section') || el.parentElement);
  });

  // Re-init inside the theme editor when this section is added/reloaded.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-siia-section]');
    if (section) init(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
